import React from 'react';
import PropTypes from 'prop-types';
import {Dialog} from '~/components/controls';

export const EditDialog = ({
  dismissable = false,
  visible,
  title,
  titleIcon,
  titleStyle,
  cancelButton,
  disableOKButton = false,
  initialValue: _initialValue,
  onOK,
  onCancel,
  onClose,
  onValidate,
  children,
}) => (
  <Dialog
    visible={visible}
    title={title}
    titleIcon={titleIcon}
    titleStyle={titleStyle}
    dismissable={dismissable}
    initialValue={_initialValue}
    onDismiss={async ({initialValue}) => {
      await onCancel?.({initialValue});
      onClose();
    }}
    buttons={[
      cancelButton && {
        text: 'Annuleren',
        onPress: async ({initialValue}) => {
          await onCancel?.({initialValue});
          onClose();
        },
      },
      {
        text: 'OK',
        disabled: disableOKButton,
        onPress: async () => {
          if (onValidate) {
            const valid = await onValidate();
            if (!valid) {
              return;
            }
          }

          if (onOK) {
            await onOK();
          }

          onClose();
        },
      },
    ].filter(Boolean)}
    options={{noPaddingContent: true}}>
    {children}
  </Dialog>
);
EditDialog.propTypes = {
  dismissable: PropTypes.any,
  visible: PropTypes.any,
  title: PropTypes.any,
  titleIcon: PropTypes.any,
  titleStyle: PropTypes.any,
  cancelButton: PropTypes.any,
  disableOKButton: PropTypes.any,
  initialValue: PropTypes.any,
  onOK: PropTypes.any,
  onCancel: PropTypes.any,
  onClose: PropTypes.any,
  onValidate: PropTypes.any,
  children: PropTypes.any,
};
